import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/services',
    name: 'Services',
    redirect: '/warranty'
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/products/:categorySlug',
    name: 'ProductCategory',
    component: () => import('../views/ProductCategory.vue')
  },
  {
    path: '/products/:categorySlug/:productSlug',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue')
  },
  {
    path: '/gallery/:id',
    name: 'GalleryDetail',
    component: () => import('../views/Gallery.vue')
  },
  {
    path: '/colors',
    name: 'Colors',
    component: () => import('../views/Colors.vue')
  },
  {
    path: '/colors/:slug',
    name: 'ColorDetail',
    component: () => import('../views/Colors.vue')
  },
  {
    path: '/insights',
    name: 'Insights',
    component: () => import('../views/Insights.vue')
  },
  {
    path: '/insights/:id',
    name: 'ArticleDetail',
    component: () => import('../views/ArticleDetail.vue')
  },
  {
    path: '/warranty',
    name: 'Warranty',
    component: () => import('../views/Warranty.vue')
  },
  {
    path: '/warranty/query',
    name: 'WarrantyQuery',
    component: () => import('../views/WarrantyQuery.vue'),
    meta: { lookupMode: 'query' }
  },
  {
    path: '/warranty/authentication',
    name: 'WarrantyAuthentication',
    component: () => import('../views/WarrantyQuery.vue'),
    meta: { lookupMode: 'authentication' }
  },
  {
    path: '/member/login',
    name: 'MemberLogin',
    component: () => import('../views/MemberLogin.vue')
  },
  {
    path: '/member/history',
    name: 'MemberHistory',
    component: () => import('../views/MemberHistory.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/dealers',
    name: 'Dealers',
    component: () => import('../views/Dealers.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Legal.vue'),
    meta: { legalKind: 'privacy' }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Legal.vue'),
    meta: { legalKind: 'terms' }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresMemberAuth) {
    const token = localStorage.getItem('memberToken')
    if (!token) {
      next('/member/login')
      return
    }
  }
  next()
})

export default router
